import { LOCATION_ROUTES } from "../../../common/constants";
import { ANALYZE_TABS } from "../constants";
import { AnalyzeTab } from "../types";

export const isAnalyzeTab = (value: string): value is AnalyzeTab =>
    Object.values(ANALYZE_TABS).includes(value as AnalyzeTab);

export const getAnalyzeTabQuery = (pathname: string, tabId: AnalyzeTab) =>
    pathname === LOCATION_ROUTES.ANALYZE_TAB ? { tabId } : {};
